export default "__VITE_IMAGE_ASSET__1a4b8be0__";